module.exports = __webpack_public_path__ + "img/graficahidrocarburos2.d109cffa.png";